export const AchievementData = [
  {
    id: 1,
    title: "Amazon India",
    content:
      "6 Students for intern role and 5 Students for FTE were selected in Amazon India from Batch 2022 at a package of 45 LPA.",
    image:
      "https://i.pinimg.com/originals/01/ca/da/01cada77a0a7d326d85b7969fe26a728.jpg",
  },
  {
    id: 2,
    title: "ServiceNow",
    content:
      "Priyanshi Rawat, B.Tech. (2022), CSE & Rupali Singh, B.Tech. (2023), CSE has secured a Full-Time Offer in ServiceNow at 34 LPA.",
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/v1675365635/T_P%20Site/ServiceNow_logo.svg_radmmv.png",
  },
  {
    id: 3,
    title: "Scaler Academy",
    content:
      "8 Students of 2023 Batch were selected for intern role at Scaler by InterviewBit.",
    image:
      "https://assets.scaler.com/assets/scaler/svg/scaler-logo-new-15cddca2e0196e677600f6671b42a288bdc89c398adc29fe82b7441503c4b129.svg.gz",
  },
  {
    id: 4,
    title: "Juspay",
    content:
      "2 Students of Batch 2022 were selected for a Full-Time Role at higher packages. 2 Students (Batch 2023) secured a Intern+FTE offer at a package of 27 LPA.",
    image: "https://www.finsmes.com/wp-content/uploads/2020/03/juspay.png",
  },
  {
    id: 5,
    title: "BEL",
    content:
      "7 Students of Batch 2022 were selected through On-Campus Drive for Research Staff Role at BEL at a package of 11 LPA.",
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/v1658577437/T_P%20Site/BEL_hjyc86.png",
  },
  {
    id: 6,
    title: "BNY Mellon",
    content:
      "3 Students of Batch 2022 were selected for Intern+FTE at BNY Mellon at a package of 16 LPA.",
    image:
      "https://pbs.twimg.com/profile_images/1230949183986847745/Lplx3rh__400x400.png",
  },
  {
    id: 7,
    title: "Lowe's India",
    content:
      "Divyanshi Singh, B.Tech. Final Year, CSE was selected in Lowe’s India at 19.34 LPA.",
    image:
      "https://www.exchangesolutions.com/wp-content/uploads/2018/06/logo_lowes.jpg",
  },
  {
    id: 8,
    title: "Walmart India",
    content:
      "4 Students of Batch 2022  were selected for FTE at Walmart at a package of 23.4 LPA.",
    image: "https://www.freepnglogos.com/uploads/walmart-logo-24.jpg",
  },
  {
    id: 9,
    title: "Microsoft India",
    content:
      "Shanya Goel  & Pragya Tewary, B.Tech. (2022), ECE has secured a Full-Time Offer in Microsoft India at 50 LPA.",
    image:
      "https://i.pinimg.com/originals/91/92/1c/91921cec4f8a8cbe3d09e596e0659d81.png",
  },
  {
    id: 10,
    title: "Nuclei",
    content:
      "2 Students of Batch 2022 were selected through On-Campus Drive for Intern+FTE at Nuclei at a package of 16 LPA.",
    image:
      "https://media.glassdoor.com/sqll/2369643/nuclei-squareLogo-1637577219784.png",
  },
  {
    id: 11,
    title: "Jupiter Money",
    content:
      "Mayank Gupta, B.Tech. (2022), CSE secured Full-Time Offer in Jupiter Money at a package of 23.7 LPA ",
    image:
      "https://play-lh.googleusercontent.com/DnJF-WDgmtEyTRqTY5CNBNFNIRLN3ztoe43h2ToqA70BQY6HJa1cyPM1s42NWipokS7X",
  },
  {
    id: 12,
    title: "Shiprocket",
    content:
      "4 Students of Batch 2022 secured FTE offers from Shiprocket  at 11-15 LPA",
    image:
      "https://clutchco-static.s3.amazonaws.com/s3fs-public/logos/167772a72c16443ac208308b55436eed.png?VersionId=z7aFZK4DWaM5VgL.sMRoms5MdZkcyaGj",
  },
  {
    id: 13,
    title: "Media.net",
    content:
      "Anuranjan Srivastava, B.Tech. (2022), CSE secured Full-Time Offer in Media.net",
    image:
      "https://i0.wp.com/apuzz.com/wp-content/uploads/2019/07/Media.net-logo.png",
  },
  {
    id: 14,
    title: "Expedia",
    content:
      "Ekansh Saxena, B.Tech. (2023), IT secured Full-Time Offer in Expedia of 42 LPA",
    image:
      "https://images.squarespace-cdn.com/content/v1/60b01bdda2ade21a4a2e8ad2/1625590386214-TB8NETK7KHJCEZKYPVZ7/Expedia.png",
  },
];
